// extracted by mini-css-extract-plugin
export var brandLockup = "_gx-5";
export var brandLogo = "_gx-6";
export var bullet = "_gx-1i";
export var bulletText = "_gx-1h";
export var bullets = "_gx-1c";
export var callout = "_gx-12";
export var calloutBody = "_gx-14";
export var calloutLabel = "_gx-13";
export var checkIcon = "_gx-1e";
export var checkList = "_gx-1b";
export var checkSvg = "_gx-1f";
export var checkText = "_gx-1g";
export var choiceCard = "_gx-x";
export var choiceDescription = "_gx-10";
export var choiceIcon = "_gx-11";
export var choiceText = "_gx-y";
export var choiceTitle = "_gx-z";
export var closeButton = "_gx-d";
export var codeText = "_gx-28";
export var compactPage = "_gx-f";
export var content = "_gx-9";
export var contentColumn = "_gx-3";
export var coverageCard = "_gx-o";
export var coverageDescription = "_gx-24";
export var coverageTitle = "_gx-23";
export var eyebrow = "_gx-i";
export var fieldCard = "_gx-m";
export var fieldDescription = "_gx-r";
export var fieldError = "_gx-s";
export var fieldHeader = "_gx-p";
export var fieldTitle = "_gx-q";
export var finalNote = "_gx-29";
export var footer = "_gx-a";
export var fulfillmentBody = "_gx-1u";
export var fulfillmentBodyText = "_gx-1v";
export var fulfillmentRow = "_gx-1r";
export var fulfillmentRows = "_gx-1q";
export var fulfillmentTitle = "_gx-1t";
export var header = "_gx-4";
export var heading = "_gx-h";
export var helperText = "_gx-1k";
export var indented = "_gx-1x";
export var inlineLink = "_gx-26";
export var inlineTitle = "_gx-2a";
export var intro = "_gx-k";
export var linkPreview = "_gx-1z";
export var listItem = "_gx-1d";
export var main = "_gx-1";
export var marketingImage = "_gx-c";
export var marketingPanel = "_gx-b";
export var modal = "_gx-0";
export var noteBody = "_gx-v";
export var noteBodyText = "_gx-w";
export var noteCard = "_gx-n";
export var noteIcon = "_gx-t";
export var noteTitle = "_gx-u";
export var numberBadge = "_gx-2e";
export var numberedStep = "_gx-2c";
export var numberedStepBody = "_gx-2f";
export var numberedStepCta = "_gx-2d";
export var numberedStepDescription = "_gx-2h";
export var numberedStepTitle = "_gx-2g";
export var numberedSteps = "_gx-2b";
export var page = "_gx-e";
export var playCircle = "_gx-18";
export var playIcon = "_gx-19";
export var policyBody = "_gx-21";
export var policyHeader = "_gx-20";
export var policyPreview = "_gx-1y";
export var policyTitle = "_gx-22";
export var progressFill = "_gx-8";
export var progressTrack = "_gx-7";
export var pseudoLink = "_gx-25";
export var pseudoLinkIcon = "_gx-27";
export var rowHeader = "_gx-1s";
export var section = "_gx-g";
export var shell = "_gx-2";
export var statusIconSuccess = "_gx-1m";
export var statusIconSvg = "_gx-1o";
export var statusIconWarning = "_gx-1n";
export var statusRow = "_gx-1l";
export var statusText = "_gx-1p";
export var stepTitle = "_gx-j";
export var strongText = "_gx-1w";
export var subHeading = "_gx-l";
export var videoEmbed = "_gx-16";
export var videoIframe = "_gx-17";
export var videoLabel = "_gx-1a";
export var videoPlaceholder = "_gx-15";
export var warningIcon = "_gx-1j";